import { graphql } from "relay-runtime"

export const chDeleteRecommendedMedicationMutation = graphql`
  mutation chDeleteRecommendedMedicationMutation($input: Ch_deleteRecommendedMedicationInput!, $connections: [ID!]!) {
    chDeleteRecommendedMedication: ch_deleteRecommendedMedication(input: $input) {
      ch_RecommendedMedication {
        id @deleteEdge(connections: $connections)
      }

      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
